import type { ReactNode } from 'react';

import {
  type IconVariantProps,
  icon as iconRecipe,
} from '@mage-ui/styled-system/recipes';
import { IconRaw } from '@/components/data-display';

export type IconProps = {
  name: string;
  classNames?: { root: string; svg: string };
} & IconVariantProps;

export const Icon = ({ name, classNames }: IconProps): ReactNode => {
  const classes = iconRecipe();
  return (
    <span className={classNames?.root ?? classes.root} aria-hidden='true'>
      <IconRaw classNames={classNames ?? classes} name={name} />
    </span>
  );
};
